// // components/Login.js
// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai"; // React Icons
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// const Login = ({ onLogin }) => {
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError("");

//     try {
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/accounts/login/",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

//       const data = await response.json();

//       if (response.ok) {
//         // Store tokens and user info in localStorage
//         localStorage.setItem("access", data.access);
//         localStorage.setItem("refresh", data.refresh);
//         localStorage.setItem("user", JSON.stringify(data.user));
//         const savedUser = localStorage.getItem("user");
//         console.log("User stored in localStorage:", savedUser);
//         // Call onLogin callback
//         onLogin(data);
//       } else {
//         setError(
//           data.message || "Login failed. Please check your credentials."
//         );
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="container-fluid vh-100 bg-light">
//       <div className="row h-100 justify-content-center align-items-center">
//         <div className="col-md-4 col-lg-4">
//           <div className="card shadow">
//             <div className="card-body p-5">
//               <div className="text-center mb-4">
//                 <h2 className="card-title">Industrial Directory</h2>
//                 <p className="text-muted">Company Login</p>
//               </div>

//               {error && (
//                 <div className="alert alert-danger" role="alert">
//                   {error}
//                 </div>
//               )}

//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3">
//                   <label htmlFor="email" className="form-label">
//                     Email
//                   </label>
//                   <div className="input-group">
//                     <input
//                       type="email"
//                       className="form-control"
//                       id="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="password" className="form-label">
//                     Password
//                   </label>
//                   <div className="input-group">
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       className="form-control"
//                       id="password"
//                       name="password"
//                       value={formData.password}
//                       onChange={handleChange}
//                       required
//                     />
//                     <button
//                       type="button"
//                       className="input-group-text"
//                       onClick={() => setShowPassword(!showPassword)}
//                     >
//                       {showPassword ? (
//                         <AiFillEyeInvisible size={20} />
//                       ) : (
//                         <AiFillEye size={20} />
//                       )}
//                     </button>
//                   </div>
//                 </div>

//                 <div className="d-grid gap-2">
//                   <button
//                     type="submit"
//                     className="btn btn-primary"
//                     disabled={isLoading}
//                   >
//                     {isLoading ? "Logging in..." : "Login"}
//                   </button>
//                 </div>
//               </form>

//               <div className="text-center mt-3">
//                 <Link to="/forgot-password" className="text-decoration-none">
//                   Forgot Password?
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// components/Login.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "./Login.css";
const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/accounts/login/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("access", data.access);
        localStorage.setItem("refresh", data.refresh);
        localStorage.setItem("user", JSON.stringify(data.user));
        const savedUser = localStorage.getItem("user");
        console.log("User stored in localStorage:", savedUser);
        onLogin(data);
      } else {
        setError(
          data.message || "Login failed. Please check your credentials."
        );
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-graphic-element login-graphic-1"></div>
        <div className="login-graphic-element login-graphic-2"></div>
        <div className="login-graphic-element login-graphic-3"></div>
      </div>

      <div className="login-content">
        <div className="login-card-wrapper">
          <div className="login-card">
            <div className="login-header">
              <div className="login-logo">
                <div className="login-logo-icon">
                  <i className="login-industry-icon">🏭</i>
                </div>
                <h1 className="login-title">Industrial Directory</h1>
              </div>
              <p className="login-subtitle">
                Welcome back! Please sign in to your account
              </p>
            </div>

            {error && (
              <div className="login-alert" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-input-group">
                <label htmlFor="email" className="login-label">
                  Email Address
                </label>
                <div className="login-input-wrapper">
                  <input
                    type="email"
                    className="login-input"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                  <span className="login-input-icon">✉️</span>
                </div>
              </div>

              <div className="login-input-group">
                <label htmlFor="password" className="login-label">
                  Password
                </label>
                <div className="login-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="login-input"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    required
                  />
                  <span className="login-input-icon">🔒</span>
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <AiFillEyeInvisible size={20} />
                    ) : (
                      <AiFillEye size={20} />
                    )}
                  </button>
                </div>
              </div>

              <div className="login-options">
                <div className="login-remember">
                  <input
                    type="checkbox"
                    id="remember"
                    className="login-checkbox"
                  />
                  <label htmlFor="remember" className="login-checkbox-label">
                    Remember me
                  </label>
                </div>
                <Link to="/forgot-password" className="login-forgot-link">
                  Forgot Password?
                </Link>
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="login-button-loading">
                    <span className="login-spinner"></span>
                    Signing in...
                  </span>
                ) : (
                  "Sign In"
                )}
              </button>
            </form>

            {/* <div className="login-footer">
              <p className="login-footer-text">
                Don't have an account?{" "}
                <Link to="/register" className="login-register-link">
                  Create one here
                </Link>
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
